var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKwaiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.10614,
    cy: 7.97528,
    r: 3.66763,
    stroke: "white",
    strokeWidth: 2.23247
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9621,
    cy: 8.77172,
    r: 3.05636,
    stroke: "white",
    strokeWidth: 1.86039
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0193 15.312H17.3978C17.7501 15.312 18.0356 15.5976 18.0356 15.9498V19.7769C18.0356 20.1292 17.7501 20.4148 17.3978 20.4148H11.0193C10.667 20.4148 10.3814 20.1292 10.3814 19.7769V15.9498C10.3814 15.5976 10.667 15.312 11.0193 15.312ZM8.46931 15.8643C8.51443 14.4948 9.63883 13.3984 11.0193 13.3984H17.3978C18.8069 13.3984 19.9492 14.5407 19.9492 15.9498V19.7769C19.9492 21.186 18.8069 22.3283 17.3978 22.3283H11.0193C9.63891 22.3283 8.51457 21.2321 8.46931 19.8627L6.51673 21.1645C5.03312 22.1535 3.0459 21.09 3.0459 19.3069V16.4201C3.0459 14.637 5.03312 13.5735 6.51673 14.5625L8.46931 15.8643ZM4.95945 16.4201C4.95945 16.1654 5.24334 16.0134 5.45528 16.1547L7.62043 17.5981C7.80978 17.7244 7.80978 18.0026 7.62043 18.1289L5.45528 19.5723C5.24334 19.7136 4.95945 19.5617 4.95945 19.3069V16.4201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKwaiIcon);
export default __webpack_public_path__ + "static/media/kwai-icon.be74357217a6b7b81c39be59b5892724.svg";
export { ForwardRef as ReactComponent };